module.exports = __webpack_public_path__ + "img/a_huo_manage3.f8e7c055.png";